import script from "./CLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./CLoading.vue?vue&type=script&setup=true&lang=ts"

import "./CLoading.vue?vue&type=style&index=0&id=23115d3c&scoped=true&lang=css"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23115d3c"]])

export default __exports__